<div class="auth-wrapper d-flex no-block justify-content-center align-items-center"
  style="background:url(assets/images/background/login-register.jpg) no-repeat center center;">
  <div class="auth-box m-3 m-md-0">
    <div id="loginform" >
      <div class="logo">
        <span class="db"><img src="assets/images/logo-icon.png" alt="logo" /></span>
        <h5 class="font-medium m-b-20">Sign In to Admin</h5>
      </div>
      <!-- Form -->
      <div class="row">
        <div class="col-12">
          <form class="form-horizontal m-t-20"[formGroup]="loginForm" (submit)="onSubmit()">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1"><i class="ti-user"></i></span>
              </div>
              <input formControlName="username" [ngClass]="{ 'is-invalid': submitted && f.username.errors }" type="text" class="form-control" placeholder="Username" aria-label="Username"
                aria-describedby="basic-addon1">
              <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                <div *ngIf="f.username.errors.required">Username richiesto</div>
              </div>
            </div>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon2"><i class="ti-pencil"></i></span>
              </div>
              <input type="password" formControlName="password" [ngClass]="{ 'is-invalid': submitted && f.password.errors }"
              class="form-control" placeholder="Password" aria-label="Password" aria-describedby="basic-addon1">
              <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                <div *ngIf="f.password.errors.required">Password richiesta</div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-12">
                <div class="custom-control custom-checkbox d-flex">
                  <!-- <input type="checkbox" class="custom-control-input" id="customCheck1"> TODO: tasto ricordami
                  <label class="custom-control-label font-14" for="customCheck1">Remember me</label> -->
                  <a (click)="showforgot()" id="to-recover"
                    class="text-dark font-14 ml-auto"><i class="fa fa-lock m-r-5"></i> Forgot pwd?</a>
                </div>
              </div>
            </div>
            <div class="text-center">
              <div class="col-xs-12 p-b-20">
                <button [disabled]="loading" class="btn btn-block btn-lg btn-info">Log In</button>
              </div>
              <!-- <div *ngIf="error">{{error}}</div> -->
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
